import { Wand2, Hand } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { SelectionMode } from './utils'

export interface SelectionModeToggleProps {
  mode: SelectionMode
  onModeChange: (mode: SelectionMode) => void
  disabled?: boolean
}

export function SelectionModeToggle({
  mode,
  onModeChange,
  disabled = false,
}: SelectionModeToggleProps) {
  return (
    <div className="flex gap-2 p-1 bg-gray-100 rounded-lg w-fit">
      <button
        onClick={() => onModeChange('auto')}
        disabled={disabled}
        className={cn(
          'flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-colors',
          disabled && 'opacity-50 cursor-not-allowed',
          mode === 'auto'
            ? 'bg-white text-primary shadow-sm'
            : 'text-gray-600 hover:text-gray-900'
        )}
      >
        <Wand2 className="w-4 h-4" />
        Auto Select
      </button>
      <button
        onClick={() => onModeChange('manual')}
        disabled={disabled}
        className={cn(
          'flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-colors',
          disabled && 'opacity-50 cursor-not-allowed',
          mode === 'manual'
            ? 'bg-white text-primary shadow-sm'
            : 'text-gray-600 hover:text-gray-900'
        )}
      >
        <Hand className="w-4 h-4" />
        Manual Select
      </button>
    </div>
  )
}
